import CryptoJS from 'crypto-js'

const key = CryptoJS.enc.Utf8.parse('5750410542ABCDEF') // 十六位十六进制数作为密钥
const iv = CryptoJS.enc.Utf8.parse('DCVSJH5750410542') // 十六位十六进制数作为密钥偏移量

// 解密方法
export function decrypt (src) {
    if (!src) { return '' }
    const dec = CryptoJS.AES.decrypt(CryptoJS.format.Hex.parse(src), key, {
        iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    })
    return CryptoJS.enc.Utf8.stringify(dec)
}

// 加密方法
export function encrypt (src) {
    if (!src) { return '' }
    const enc = CryptoJS.AES.encrypt(src, key, {
        iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    })
    return enc.ciphertext.toString()
}
